import React, { Component }  from 'react'

export default class StatusIcon extends Component{
	render(){
		let { props } = this
		return(
			!props.type?
			<div></div>
			:
			<div
				style={{
					marginLeft: "10px"
				}}
			>
				{props.type == "merchant"?
						<img
							src={"/manager/static/img/vendor-green.png"}
							style={{
							  width: "20px"
							  , position: "relative"
							  , top: "-2px"
							}}
						/>
				:props.type == "agent"?
					<img
						src={`/assets/manager/img/agents_g48.png`}
						style={{
						  width: "20px"
						  , position: "relative"
						  , top: "-2px"
						}}
					/>
				:props.type == "repairman"?
					<img
						src={`/assets/manager/img/repairmen_g48.png`}
						style={{
						  width: "20px"
						  , position: "relative"
						  , top: "-2px"
						}}
					/>
				:
					<img
						src={"/manager/static/img/tenant-green.png"}
						style={{
						  width: "22px"
						  , position: "relative"
						  , top: "0px"
						}}
					/>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/vendorForm/StatusIcon.js